module.exports = __webpack_public_path__ + "img/app-download@2x.22dad67f.png";